import { useOnboardingTranslation } from '@libs/utils/translations'
import type { TFunction } from 'react-i18next'
import { z } from 'zod'

const createBaseAccountCompanyInfoSchema = (tFunction?: TFunction) => {
  return z.object({
    locationCount: z
      .string()
      .trim()
      .min(
        1,
        tFunction?.(
          'onboarding.qualification.company.validation.locationCount.error'
        )
      ),
    employeeCount: z
      .string()
      .trim()
      .min(
        1,
        tFunction?.(
          'onboarding.qualification.company.validation.employeeCount.error'
        )
      ),
    industry: z
      .string()
      .trim()
      .min(
        1,
        tFunction?.(
          'onboarding.qualification.company.validation.industry.error'
        )
      ),
    isFranchise: z.boolean(),
    country: z
      .string()
      .trim()
      .min(
        1,
        tFunction?.('onboarding.qualification.company.validation.country.error')
      )
  })
}

// Base schema without translations (for validation purposes)
export const baseAccountCompanyInfoSchema = createBaseAccountCompanyInfoSchema()

export const useAccountCompanyInfoSchema = () => {
  const { t } = useOnboardingTranslation()
  return createBaseAccountCompanyInfoSchema(t)
}

export type AccountCompanyInfoFormType = z.infer<
  typeof baseAccountCompanyInfoSchema
>

export const isAccountCompanyInfoValid = (
  profile: unknown
): profile is AccountCompanyInfoFormType => {
  return baseAccountCompanyInfoSchema.safeParse(profile).success
}
